import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from '../../../_services/admin.service';
import { Permissions } from '../../../_services/permissions';
import { ACLFeature } from '../../../_models/acl-feature';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'edit-roleexport',
  styleUrls: ['roleexport.less'],
  templateUrl: 'roleexport.component.html',
})
export class RoleexportComponent implements OnInit {

  canExportRoleOverview = false;

  constructor(
    private admin: AdminService,
    private permissions: Permissions,
    private router: Router
  ) {}

  ngOnInit() {
    this.permissions.hasFeature(ACLFeature.EXPORT_ACL_MATRIX)
      .subscribe((success) => {
        this.canExportRoleOverview = success;
      });
  }

  exportRoleOverview() {
    this.admin.downloadRoleOverview().subscribe((res) => {
      //noinspection TypeScriptUnresolvedFunction
      const now = new Date();
      FileSaver.saveAs(res, `role-overview-${now.toISOString()}.xlsx`);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/management/components/roleexport/roleexport.component.ts